import React,{Children, useState} from 'react'
import './Navbar.scss'
import Logo from '../../assets/logo.jpg'
import {motion} from "framer-motion"
import {HiMenu} from 'react-icons/hi'
import {IoMdClose} from 'react-icons/io'
import ModalBox from './ModalBox'

function Navbar() {
    const [toogle,setToggle]=useState(false);
    const [modal,setModal]=useState(false);
  return (
    <nav className='app__navbar'>
        <div className='app__logo' onClick={()=>setModal(!modal)} >
            <img src="https://avatars.githubusercontent.com/u/104312822?v=4" alt="logo" />
        </div>
        {
            modal&& <ModalBox/>
        }
        <ul className='app__navbar-links'>
            {["home","about","work","skills"].map((menu=>{
                return <li key={`link-${menu}`} className="app__flex p-text">
                    <div></div>
                    <a href={`#${menu}`}>{menu}</a>
                </li>
            }))}
        </ul>
        <div className='app__navbar-menu'>
            <HiMenu onClick={()=>setToggle(true)}/>
            {
              toogle && (
                // whileInView is an animation call
                <motion.div whileInView={{x:[300,0]}} transition={{duration:0.85,ease:"easeInOut"}}>
                    <IoMdClose onClick={()=>setToggle(false)} />
                    <ul>
                    {Children.toArray(["home","about","work","skills"].map(menu=>(
                        <li  className="app__flex p-text">
                        <a href={`#${menu}`} onClick={()=>setToggle(false)}>{menu}</a>
                    </li>
                    )))}
                    </ul>
                </motion.div>
              )
            }
        </div>
    </nav>
  )
}

export default Navbar
